import {z} from 'zod';
import {zodResolver} from "@primevue/forms/resolvers/zod";

class Validation {

    static vm;

    static init(app) {
        this.vm = app.config.globalProperties;
        this.vm.$validation = Validation;
    }

    /* Element Plus Rules */
    static ep = {

        required: (trigger = ['blur', 'change']) => ({
            required: true,
            message: Validation.vm.$t('validation.required'),
            trigger
        }),

        email: (trigger = ['blur', 'change']) => ([
            {
                required: true,
                message: Validation.vm.$t('validation.required'),
                trigger
            },
            {
                type: 'email',
                message: Validation.vm.$t('validation.email'),
                trigger
            }
        ]),

        password: (min = 6, trigger = ['blur', 'change']) => ({
            min,
            message: Validation.vm.$t('validation.password', {min}),
            trigger
        })
    };

    /* PrimeVue (Zod) Rules */
    static z = {

        required: () =>
            z.string().min(1, {
                message: Validation.vm.$t('validation.required')
            }),

        selectRequired: () =>
            z.any().refine(val => val !== null && val !== undefined && val !== '', {
                message: Validation.vm.$t('validation.required')
            }),

        email: () =>
            z.string()
                .min(1, {message: Validation.vm.$t('validation.required')})
                .email({message: Validation.vm.$t('validation.email')}),

        password: (min = 6) =>
            z.string().min(min, {
                message: Validation.vm.$t('validation.password', {min})
            }),

        booleanRequired: () =>
            z.boolean().refine(val => val === true, {
                message: Validation.vm.$t('validation.required')
            }),

        checkboxRequired: () =>
            z.array(z.string()).min(1, {
                message: Validation.vm.$t('validation.required')
            }),

        otp: (min = 6) =>
            z.string().min(min, {
                message: Validation.vm.$t('validation.required')
            }),

        length: (min = 1) =>
            z.array(z.any()).min(min, {
                message: Validation.vm.$t('validation.required')
            }),

    };
}

export default Validation;